var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneHandset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone-handset") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-handset",
    fill: "#2773FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.987,20 C14.216,20 12.332,19.498 10.387,18.508 C8.594,17.595 6.823,16.288 5.265,14.728 C3.707,13.168 2.402,11.395 1.49,9.601 C0.502,7.655 6.66133815e-16,5.771 6.66133815e-16,4 C6.66133815e-16,2.852 1.07,1.743 1.529,1.32 C2.19,0.711 3.23,6.66133815e-16 3.986,6.66133815e-16 C4.362,6.66133815e-16 4.802,0.246 5.373,0.774 C5.798,1.168 6.277,1.702 6.756,2.318 C7.045,2.69 8.486,4.589 8.486,5.5 C8.486,6.247 7.641,6.767 6.747,7.316 C6.401,7.528 6.044,7.748 5.786,7.955 C5.51,8.176 5.461,8.293 5.453,8.319 C6.402,10.685 9.303,13.586 11.668,14.534 C11.689,14.527 11.806,14.481 12.031,14.201 C12.238,13.943 12.458,13.585 12.67,13.24 C13.22,12.346 13.739,11.501 14.486,11.501 C15.397,11.501 17.296,12.942 17.668,13.231 C18.284,13.71 18.818,14.189 19.212,14.614 C19.74,15.184 19.986,15.625 19.986,16.001 C19.986,16.757 19.275,17.8 18.667,18.464 C18.243,18.926 17.134,20.001 15.986,20.001 L15.987,20 Z M3.981,1 C3.713,1.005 2.992,1.333 2.208,2.055 C1.464,2.741 1.001,3.486 1.001,4 C1.001,10.729 9.265,19 15.987,19 C16.5,19 17.245,18.535 17.931,17.787 C18.654,16.999 18.982,16.275 18.987,16.006 C18.955,15.816 18.429,15.077 16.99,13.969 C15.753,13.017 14.75,12.506 14.492,12.5 C14.474,12.505 14.362,12.548 14.135,12.836 C13.938,13.087 13.727,13.43 13.522,13.762 C12.962,14.673 12.433,15.534 11.664,15.534 C11.54,15.534 11.418,15.51 11.301,15.463 C8.676,14.413 5.572,11.309 4.522,8.684 C4.396,8.369 4.376,7.875 4.996,7.313 C5.326,7.014 5.782,6.734 6.224,6.462 C6.556,6.258 6.9,6.047 7.15,5.849 C7.438,5.622 7.481,5.51 7.486,5.492 C7.479,5.234 6.969,4.231 6.017,2.994 C4.909,1.555 4.17,1.03 3.98,0.997 L3.981,1 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneHandset);
export default __webpack_public_path__ + "static/media/phone-handset.70feff4aa4c25bd25288b1dbebab5cd9.svg";
export { ForwardRef as ReactComponent };